<template>
  <div v-if="historyColors.length" class="x-color-picker__wrapper">
    <p class="x-color-picker__title">最近使用</p>
    <ul class="x-color-picker__list">
      <li
        v-for="(item, i) in colors"
        :key="i"
        class="x-color-picker__list-item"
      >
        <ul class="x-color-picker__children">
          <li
            v-for="(color, j) in item"
            :key="j"
            class="x-color-picker__children-item"
            :style="{
              width: `${colorRoot.colorBlockSize}px`,
              backgroundColor: color,
            }"
            @click.stop="__confirm(color)"
          ></li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import baseMixin from './mixins'
export default {
  name: 'XThemeColor',
  mixins: [baseMixin],
  props: {
    historyColors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    colors() {
      return [this.historyColors]
    },
  },
}
</script>

<style lang="scss" scoped></style>
